import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ArrowRight, Check, Store } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import Header from '../components/Header';
import MasterAccess from '../components/MasterAccess';

const API = process.env.REACT_APP_BACKEND_URL;

const ClienteJaConfigurar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const [form, setForm] = useState({
    nome: '',
    negocio: '',
    telefone: '',
    email: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Create slug from name
      const slug = form.nome
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 20);

      const res = await fetch(`${API}/api/clienteja/assinantes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          slug,
          nome: form.nome,
          negocio: form.negocio,
          telefone: form.telefone,
          email: form.email,
          plano: 'basico'
        })
      });

      const data = await res.json();
      
      if (data.success) {
        navigate(`/clienteja/painel/${data.slug}`);
      } else {
        setError(data.detail || 'Erro ao criar conta');
      }
    } catch (err) {
      setError('Erro de conexão. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-cyan-50">
      <Header />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-md mx-auto">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-teal-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Users className="text-teal-600" size={32} />
            </div>
            <h1 className="text-2xl font-bold text-slate-900">Criar sua conta</h1>
            <p className="text-slate-500 mt-2">Em 1 minuto você está pronto</p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-6 space-y-4">
            <div>
              <Label htmlFor="nome">Seu nome</Label>
              <Input
                id="nome"
                data-testid="input-nome"
                placeholder="João Silva"
                value={form.nome}
                onChange={(e) => setForm({...form, nome: e.target.value})}
                required
              />
            </div>

            <div>
              <Label htmlFor="negocio">Nome do negócio</Label>
              <Input
                id="negocio"
                data-testid="input-negocio"
                placeholder="Loja do João"
                value={form.negocio}
                onChange={(e) => setForm({...form, negocio: e.target.value})}
                required
              />
            </div>

            <div>
              <Label htmlFor="telefone">WhatsApp</Label>
              <Input
                id="telefone"
                data-testid="input-telefone"
                placeholder="11 99999-9999"
                value={form.telefone}
                onChange={(e) => setForm({...form, telefone: e.target.value})}
                required
              />
            </div>

            <div>
              <Label htmlFor="email">Email (opcional)</Label>
              <Input
                id="email"
                data-testid="input-email"
                type="email"
                placeholder="joao@email.com"
                value={form.email}
                onChange={(e) => setForm({...form, email: e.target.value})}
              />
            </div>

            {error && (
              <div className="text-red-500 text-sm bg-red-50 p-3 rounded-lg">
                {error}
              </div>
            )}

            <Button 
              type="submit" 
              data-testid="btn-criar-conta"
              className="w-full bg-teal-600 hover:bg-teal-700 py-6"
              disabled={loading}
            >
              {loading ? 'Criando...' : 'Criar minha conta'}
              <ArrowRight size={18} />
            </Button>

            {/* Benefits */}
            <div className="pt-4 border-t space-y-2">
              <p className="text-xs text-slate-400 text-center mb-3">Incluso no plano gratuito:</p>
              {['Até 50 clientes', 'Cobranças ilimitadas', 'Lembretes por WhatsApp'].map((b, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-slate-600">
                  <Check size={14} className="text-teal-500" />
                  {b}
                </div>
              ))}
            </div>
          </form>
        </div>
      </div>

      {/* Master Access */}
      <MasterAccess 
        produto="clienteja" 
        slug={form.nome.toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 20)}
        onSuccess={() => navigate(`/clienteja/painel/${form.nome.toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0, 20)}`)}
      />
    </div>
  );
};

export default ClienteJaConfigurar;
